import React, { Component } from 'react';
import { Translate } from '$common';



export default class Date extends Component {
  static type = 'date';
  static elementName = Translate.get('date');
  static icon = 'calendar';

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/task-form/question-types/date.js